import { CertificateDefinition } from "./CertificateDefinition.js";

export interface GetCertificatesResponse {
    results: CertificateDefinition[];
}